import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute() {
  const { admin, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center">
        <div className="pz-bounce"><span /><span /><span /></div>
      </div>
    );
  }
  if (!admin) return <Navigate to="/admin/login" replace />;
  return <Outlet />;
}
